module.exports = __webpack_public_path__ + "static/austin_downtown-c2c15969276d1f23224b80e82e4d1ea6.jpg";